import application from 'application/application';

import template from './inss-details.template.html';
import controller from './inss-details.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider.state('root.default.movements.inssDetails', {
			url:
				'/inss/detalhar?movements&titulo&paginaAtual&pasta&numeroProcesso&idProcesso&readStatus&pastaProcesso',
			views: {
				'movements@root.default.movements': {
					templateUrl: template,
					controller
				}
			},
			data: {
				documentTitle: 'Detalhes INSS'
			}
		});
	}
]);
